import React from 'react'
import { observer } from 'mobx-react'
import { Address } from '../commonQuestions/Address'

export default {
  title: 'Business.Address',
  description: 'Business.AddressDescription',
  component: observer((props) => {
    return <Address {...props} testID="business_address" />
  }),
}
